/* eslint-disable */
export default {
  actions: {
    addDamage: 'Dodaj',
    login: 'Login',
    select: 'Wybierz',
    clear: 'Clean',
    continue: 'Kontynuuj',
    cancel: 'Anuluj',
    import: 'Import',
    export: 'Eksport',
    exportAll: 'Eksportuj wszystko',
    selectFile: 'Wybierz plik',
    search: 'Szukaj',
    save: 'Zapisz',
    delete: 'Usuń'
  },
  downloadModal: {
    title: 'Pobranie pliku',
    text:
      'Pobieranie pliku może potrwać kilka minut  prosimy nie opuszczać strony'
  },
  // component: 'meble'
  furniture: {
    title: 'Meble',
    empty: {
      short: 'Brakujące odniesienie do roszczenia',
      long: 'Aby móc dodać szkodę meblową  należy wprowadzić sygnaturę szkody'
    },
    kindOfProperty: 'Typ nieruchomości',
    kindOfPropertyOptions: {
      owner: 'Właściciel',
      renter: 'Najemca'
    }
  },
  // component: 'warrantyLayout'
  warrantyLayout: {
    registerSinister: 'Zapisać roszczenie',
    newSinister: 'Nowe roszczenie',
    registeredDamages:
      '0 x Dommage enregistré | 1 x Dommage enregistré | count} x Dommages enregistrés',
    modals: {
      newSinister: {
        title: 'Nowy pozew. Czy na pewno?',
        body: 'Wszystkie dane zostaną przywrócone'
      }
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: 'Data zakupu'
    },
    priceDamage: {
      literal: 'Cena zakupu'
    }
  },
  // component: 'warrantyRef'
  warrantyRef: {
    sinisterRef: {
      literal: 'Odnośnik do roszczenia'
    },
    secondaryRef: {
      literal: 'Odniesienie wtórne (opcjonalnie)'
    }
  },
  // component: 'warrantyProps'
  warrantyProps: {
    aboutProperty: 'Informacje dodatkowe',
    address: {
      literal: 'Adres',
      placeholder: 'Podaj lokalizację'
    },
    zipCode: {
      literal: 'Kod pocztowy'
    },
    propertyType: {
      literal: 'Typ nieruchomości',
      options: {
        appartment: 'Mieszkanie',
        maison: 'Dom',
        local_commercial: 'Lokale użytkowe'
      }
    },
    residentType: {
      literal: 'Typ mieszkańca',
      options: {
        propietarie: 'Właściciel',
        locataire: 'Najemca',
        propietarie_non_occupant: 'Właściciel nie zamieszkujący'
      }
    },
    moreThanTwoYears: {
      literal: 'Wiek budynku',
      options: {
        less: 'Mniej niż 2 lata',
        more: 'Więcej niż 2 lata'
      }
    },
    map: {
      empty: {
        title: 'Brak adresu',
        text: 'Proszę podać prawidłowy adres'
      }
    },
    nameApplicant: {
      literal: 'Imię i nazwisko osoby ubezpieczonej',
      placeholder: 'Podaj nazwę'
    },
    formsList: 'Formularze',
    fnolIdsList: 'Umowa',
    userIdsList: 'Typ użytkownika',
    buttonLink: {
      literal: 'Zobacz link użytkownika'
    },
    modalLink: {
      buttonGenerateLink: 'Wygeneruj link',
      buttonCancel: 'Anuluj',
      title: 'Link użytkownika',
      alertMessage: 'Należy uzupełnić dodatkowe informacje.',
      alertAction: 'Uzupełnij dodatkowe informacje'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Informacje dodatkowe',
      buttonCancel: 'Anuluj',
      title: 'Informacje uzupełniające',
      send: 'Wyślij',
      personalInfo: {
        title: '1. Dane osobowe',
        name: 'Nazwa',
        surname: 'Nazwisko',
        phone: 'Telefon',
        city: 'Miasto'
      },
      contractInfo: {
        title: '2. Umowa',
        isValid: 'Czy umowa jest ważna?',
        deductibles: 'Nieruchomości podlegające odliczeniu (€)',
        allowance: 'Dodatek za upiększanie (€)',
        furnitureAllowance: 'Dodatek na meble (€)',
        swimmingPool: 'Opcja(-y) wykupiona(-e) - Basen',
        externalFittings:
          'Opcja (opcje) subskrybowana(e) - Wyposażenie zewnętrzne'
      },
      verifications: {
        title: '3. Kontrole',
        beforeSinister:
          'Brak aktualnych roszczeń pod tym samym adresem z tym samym zakresem ubezpieczenia, które wystąpiły w ciągu 15 dni przed lub po tym roszczeniu',
        GaG: 'Nazwa Gré à gré',
        ren: 'Nazwa Ren',
        cause: 'Co było przyczyną straty'
      },
      modalInformation: {
        title: 'Brakujące informacje',
        literal: 'Aby utworzyć link, najpierw należy uzupełnić dodatkowe informacje.',
        literal2: 'Proszę uzupełnić tę sekcję przed kontynuowaniem.',
        cancel: 'Anuluj',
        completeInformation: 'Uzupełnij informacje',
      }
    },
    optionsUserType: {
      insured: 'Samopomoc generyczna',
      professional: 'Selfcare BillMA Profesjonalne',
      billma_insured: 'Selfcare BillMA ubezpieczony',
      billma_agent: 'Selfcare Agenta',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare RIK Profesjonalne',
      ren_insured: 'Selfcare Ren Ubezpieczony'
    },
    clientPhoneNumber: 'Numer telefonu',
    clientEmail: 'Email',
    clientValidationType: 'Typ walidacji',
    countryCode: 'Prefiks',
    example: 'Przykład.',
    requiredFields: {
      title: 'Pola obowiązkowe',
      text: 'Nieuzupełnione pola obowiązkowe'
    }
  },
  // component: 'warrantySticky'
  warrantySticky: {
    analyze: 'Analyze',
    generateReport: 'Generuj raport',
    generateReportFnol: 'Opis szkody',
    materialListBtn: 'Wykaz sprzętu',
    damageSummary: {
      title: 'Wycena aktywów',
      tableHead: {
        damages: 'Odszkodowania',
        greAGre: 'DIY',
        reparationNetwork: 'Naprawa sieci',
        reparationExcept: 'Naprawy poza siecią'
      },
      tableSubHead: {
        embellishments: 'Upiększanie',
        immobilier: 'Nieruchomości',
        mobilier: 'Meble'
      },
      tableMain: {
        manpowerHours: 'Prace (godziny)',
        manpowerCost: 'Praca (euro)',
        materialCost: 'Sprzęt',
        totalCost: 'Razem',
        priceWithoutTaxes: 'Bez podatków',
        priceWithTaxes: 'wszystkie podatki wliczone'
      },
      description: {
        quantity: 'Ilość'
      }
    },
    damageCounters: {
      gag: 'Do it yourself',
      materials: 'Materiały i dostawy',
      estimatedTime: 'Szacowany czas',
      authorizedNetworkRepair: 'Zatwierdzona naprawa sieci',
      artessianRepair: 'Remonty poza siecią',
      immediate: 'Natychmiastowy',
      difference: 'Opóźnienie',
      ensembleImage: 'Pełny obraz',
      presImage: 'Zbliżenie',
      totalPrice: 'Cena całkowita'
    },
    manPower: {
      title: 'Zmiana cen pracy',
      calculatePrice: 'Oblicz cenę',
      cancel: 'Anuluj',
      setPrice: 'Ustal ceny'
    },
    materialList: {
      title: 'Materiały i robocizna',
      manpowerTime: 'Praca (godziny)',
      manpowerPrice: 'Praca (€)',
      manpowerTitle: 'Cena pracy',
      materials: 'Materiały',
      gag: 'Indemnizacja Do It Yourself',
      downloadPDF: 'Pobierz PDF',
      cancel: 'Anuluj',
      send: 'Wyślij'
    }
  },

  // component: 'login'
  login: {
    title: 'Moja szkoda',
    titleMA: 'MAValue',
    text: 'Your Claims Valuation Tool',
    authenticationError: 'Błąd uwierzytelnienia',
    authenticationBlock:
      'Logowanie zablokowane  spróbuj ponownie po kilku minutach',
    authenticationOk: 'Login prawidłowy',
    sso_processing: 'Weryfikowanie tożsamości...',
    sso_wait: 'Proszę czekać chwilę.',
    sso_error_title: 'Błąd uwierzytelnienia',
    sso_error_msg: 'Wystąpił błąd podczas logowania przez SSO. Spróbuj ponownie lub skontaktuj się z administratorem.',
    inputs: {
      username: 'Nazwa użytkownika',
      password: 'Hasło'
    },
    login: 'Login'
  },
  // component: 'error'
  error: {
    title: 'Moja szkoda',
    titleMA: 'MAValue',
    text: 'Strona  której szukasz  nie istnieje',
    btn: 'Powrót'
  },
  // component: 'adminLayout'
  adminLayout: {
    modals: {
      import: {
        title: 'Parametry importu',
        description:
          'Aby dodać lub zmodyfikować parametry należy zaimportować plik. Jeśli parametr nie istnieje, zostanie utworzony lub zmodyfikowany, jeśli istnieje.'
      },
      export: {
        title: 'Ustawienia eksportu',
        description: 'Proszę wybrać pola  które mają być filtrowane'
      }
    },
    filters: {
      warranty: 'Grupa Gwarancyjna',
      subwarranty: 'Podgrupa gwarancyjna'
    },
    notifications: {
      importedFile: {
        title: 'Plik importowany',
        body: 'Tabela zostanie załadowana'
      }
    }
  },
  // component: 'parameters (gagadmin)'
  gagParameters: {
    title: 'Parametry',
    table: {
      paramName: 'Nazwa parametru',
      paramValue: 'Wartość parametru',
      customizable: 'Edytowalne'
    }
  },
  // component: 'repMat (gagadmin)'
  gagRepMat: {
    title: 'Materiały naprawcze',
    table: {
      rep_type_code: 'Kod',
      rep_description: 'Opis',
      rep_mat: 'Materiał',
      mat_format_sale: 'Format sprzedaży',
      dam_measure_unit: 'Jednostka miary',
      conv_unit_per_mat_measure: 'Jednostka przeliczeniowa na miarę materiału',
      mat_unit_price: 'Cena',
      is_hours: 'Tylko godziny',
      image: 'Image'
    }
  },
  // component: 'zipCode (gagadmin)'
  gagZipCode: {
    title: 'Kody pocztowe',
    table: {
      dept_code: 'Kod',
      zip_code_min: 'Minimalny kod pocztowy',
      zip_code_max: 'Maksymalny kod pocztowy',
      country: 'Kraj',
      clean_cost: 'Koszt',
      displacement_hours: 'Godziny podróży',
      coef: '*** coef',
      factmin: '*** factmin'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: 'Dostosować do wieku klienta',
    table: {
      interval_age_start: 'Minimalny wiek',
      interval_age_end: 'Maksymalny wiek',
      age_coef: 'Współczynnik'
    }
  },
  // component: 'userLimits (gagadmin)'
  gagUserLimits: {
    title: 'Limity'
  },
  table: {
    user: 'Użytkownik',
    hour_price_max_limit: 'Cena/godzina max',
    hour_price_min_limit: 'Min. cena/godzinę'
  },
  // component: 'salaries (gagadmin)'
  gagSalaries: {
    title: 'Wynagrodzenia',
    table: {
      zip_code: 'Kod pocztowy',
      csp: '*** csp',
      salary_hour: 'Cena/godzinę'
    }
  },
  // component: 'parameters (admin)'
  parameters: {
    title: 'Ustawienia',
    table: {
      paramName: 'Nazwa parametru',
      paramValue: 'Wartość parametru',
      customizable: 'Edytowalny',
      type: 'Rodzaj'
    }
  },
  // component: 'reparations (admin)'
  reparations: {
    title: 'Naprawa',
    warrantyid: 'Grupa gwarancyjna',
    subcategory: 'Podkategoria',
    table: {
      repTypeCode: 'Kod naprawy',
      description: 'Opis',
      type: 'Typ naprawy',
      surfaceUnit: 'Jednostka miary',
      damagesType: 'Rodzaj szkody',
      priceCalcForm: 'Formularz kalkulacji ceny'
    }
  },
  // component: 'coefficients (admin)'
  coefficients: {
    title: 'Współczynniki',
    table: {
      repCodeType: 'Kod naprawy',
      description: 'Opis',
      matSRen: 'Mat_s_RIK',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Cena'
    }
  },
  // component: 'depreciations (admin)'
  depreciations: {
    title: 'Vetus',
    table: {
      repTypeCode: 'Kod naprawy',
      description: 'Opis',
      years: 'Lata',
      depreciationPerc: 'Procent naprawy'
    }
  },
  // component: 'transversalCosts'
  transversalcosts: {
    title: 'Działania dodatkowe',
    table: {
      damageType: 'Rodzaj szkody',
      componentName: 'Nazwa składnika',
      description: 'Opis',
      costFormat: 'Koszt formatu',
      value: 'Val'
    }
  },
  // component: 'users'
  users: {
    title: 'Użytkownicy',
    newUser: 'Nowy użytkownik',
    table: {
      username: 'Nazwa użytkownika',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'E-mail',
      role: 'Role',
      company: 'Firma'
    },
    modals: {
      newUser: {
        title: 'Nowy użytkownik'
      },
      editUser: {
        title: 'Modyfikuj użytkownika'
      },
      deleteUser: {
        title: 'Usuniesz tego użytkownika',
        body: 'To działanie jest nieodwracalne. Czy chcesz kontynuować?'
      },
      user: {
        fields: {
          firstName: 'Imię',
          lastName: 'Nazwisko',
          username: 'Nazwa użytkownika',
          email: 'Email',
          company: 'Nazwa firmy',
          role: 'Rola użytkownika',
          password: 'Hasło',
          repeatPassword: 'Powtórzenie hasła'
        }
      }
    },
    filters: {
      company: 'Filtruj według firmy',
      role: 'Filtruj według roli'
    }
  },
  // component: 'forms'
  adminForms: {
    filterLabel: 'Filtruj według formularza',
    import: {
      title: 'Parametry importu',
      description:
        'Aby dodać lub zmodyfikować parametry należy zaimportować plik. Jeśli parametr nie istnieje, zostanie utworzony lub zmodyfikowany, jeśli istnieje.'
    },
    export: {
      title: 'Ustawienia eksportu',
      description:
        'Aby dodać lub zmienić ustawienia, należy wyeksportować plik, a następnie ponownie go zaimportować.'
    },
    toast: {
      success: 'Plik został przetworzony pomyślnie',
      error: 'Plik nie mógł zostać przetworzony'
    },
    modal: {
      title: 'Dokument jest w trakcie przetwarzania',
      description:
        'Ten proces może potrwać kilka minut. Proszę nie zamykać aplikacji'
    }
  },
  // component: 'small device modal'
  smDevModal: {
    title: 'Niewłaściwa rozdzielczość ekranu',
    text:
      'Treść  którą chcesz wyświetlić  nie jest dostępna dla Twojej rozdzielczości ekranu. Proszę spróbować ponownie z urządzenia o rozdzielczości wyższej niż 1024 pikseli'
  },
  // notification: {
  notifications: {
    error: {
      0: {
        title: 'Błąd',
        body: 'Błąd podczas działania'
      },
      400: {
        title: 'Pole obowiązkowe niewypełnione',
        body: 'Proszę przejrzeć niewypełnione pola'
      },
      500: {
        title: 'Błąd',
        body: 'Błąd generyczny'
      },
      409: {
        title: 'Błędna identyfikacja',
        body: 'Roszczenie już istnieje'
      },
      title: 'Błąd',
      body: 'Błąd podczas działania'
    },
    addDamage: {
      title: 'Szkody powstałe',
      body: 'Szkoda powstała prawidłowo'
    },
    newSinister: {
      title: 'Nowe roszczenie',
      body: 'Identyfikator roszczenia został zmieniony'
    },
    deleteDamage: {
      title: 'Szkody zlikwidowane',
      body: 'Uszkodzenia zostały zlikwidowane prawidłowo'
    },
    pdfDamages: {
      title: 'Raport utworzony',
      body: 'Raport utworzony prawidłowo'
    },
    pdfMaterial: {
      title: 'Raport utworzony',
      body: 'Raport utworzony prawidłowo'
    },
    mailPdfMaterial: {
      title: 'Email wysłany',
      body: 'Email wysłany poprawnie',
      error: {
        title: 'Nieważny e-mail',
        body: 'Proszę podać prawidłowy adres e-mail'
      }
    },
    moCalculation: {
      title: 'Ceny zaktualizowane',
      body: 'Przeładowanie bieżącego raportu'
    },
    changeLanguage: {
      title: 'Zmiana języka',
      body: 'Zwolnienie'
    },
    loadSinisterOK: {
      title: 'Roszczenia załadowane',
      body: 'Informacje o aktualizacji'
    },
    loadSinisterKO: {
      title: 'Błąd roszczenia',
      body: 'Błąd podczas ładowania strat'
    },
    paramChanged: {
      title: 'Parametr zmieniony',
      body: 'Tabela zostanie zaktualizowana automatycznie'
    },
    user: {
      isRequired: {
        title: 'Brakujące pola',
        body: 'Prosimy o poprawne wypełnienie wszystkich pól'
      },
      isEmail: {
        title: 'Nieprawidłowy e-mail',
        body: 'Wprowadzony e-mail jest nieprawidłowy'
      },
      isSamePassword: {
        title: 'Powtórzenie hasła',
        body: 'Hasło nie pasuje'
      },
      createdUser: {
        title: 'Użytkownik utworzony',
        body: 'Widok w trakcie aktualizacji`'
      },
      modifiedUser: {
        title: 'Użytkownik zmodyfikowany',
        body: 'Widok w trakcie aktualizacji'
      },
      deletedUser: {
        title: 'Usunięty użytkownik',
        body: 'Widok w trakcie aktualizacji'
      },
      error: {
        400: {
          title: 'Brakujące pola',
          body: 'Sprawdź pola formularza'
        },
        500: {
          title: 'Błąd',
          body: 'Wystąpił błąd'
        },
        409: {
          title: 'Błąd identyfikacji`',
          body: 'Użytkownik już istnieje`'
        }
      }
    }
  },
  // charts view: {
  charts: {
    mapTitle: 'Roszczenia według lokalizacji',
    sinisterEvolutionTitle: 'Oceny i średnie koszty ponoszone miesięcznie',
    tableTitle: 'Tabela danych',
    noDataAvailable: 'Brak dostępnych danych',
    barChartDamageSubType: 'Średni koszt rodzaju pokrycia',
    barChartDamageType: 'Średni koszt według rodzaju szkody',
    barChartCompensationType: 'Koszty według rodzaju odszkodowania',
    pieChart: 'Podział na podrodzaje szkód',
    titleView: 'Dashboard',
    downloadData: 'Dane do pobrania',
    fromDate: 'Od',
    toDate: 'Do',
    hintFromDate: "Proszę wybrać 'od daty'",
    hintToDate: "Proszę wybrać 'do daty'",
    tableHeadTitle: {
      company: 'Firma',
      userName: 'Nazwa użytkownika',
      l1: 'Poziom 1',
      l2: 'Poziom 2',
      l3: 'Poziom 3',
      l4: 'Poziom 4',
      q: 'q',
      averageCost: 'Średni koszt',
      total: 'Razem'
    },
    bubbleChartLegend: {
      price: 'Kwota',
      damagesCount: 'Częstotliwość'
    }
  },
  // search view: {
  search: {
    secondaryRef: 'Odniesienie wtórne',
    status: 'Status',
    gag: 'DIY',
    ren: 'RIK',
    asp: 'ASP',
    createdDate: 'Data utworzenia',
    updatedDate: 'Data aktualizacji'
  },
  // tutorials view: {
  tutorials: {
    title: 'Tutoriale',
    subtitle: 'Tutoriale'
  },
  // Biens obiliers View: {
  biensMobiliers: {
    title: 'Mienie ruchome',
    searchEmpty: {
      search: 'Twoje poszukiwania',
      notFound: 'nie uzyskał żadnych wyników'
    },
    text:
      'Skorzystaj z wyszukiwarki lub przejrzyj menu boczne  aby znaleźć poszukiwaną pozycję. Możesz też wybrać z naszych najpopularniejszych kategorii'
  },

  // dashboard view: {
  dashboard: {
    GAG: {
      title: 'Przeprowadzone badania gagowe i teleoceny',
      downloadData: 'Dane do pobrania',
      filters: {
        date: 'Okres',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data końcowa',
        orderBy: 'Sortuj według',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Total DIY',
          sinisterTotal: 'Total televal',
          conversion: 'Konwersja'
        }
      },
      kpis: {
        gag: 'DIY osiągnięty',
        TE: 'Telefony wykonywane',
        gagWeek: 'Gest z 1 DIY/tydzień',
        gagSans: 'Gest bez DIY'
      },
      table: {
        headers: {
          manager: 'Manager',
          conversion: 'Konwersja',
          weeks: 'Weeks',
          evolution: 'Ewolucja',
          total: 'Totals',
          totalGAG: 'Total DIY',
          totalTE: 'Total televal',
          TMO: 'TMO'
        }
      }
    }
  },

  // common: {
  common: {
    surface: 'Powierzchnia',
    line: 'Powierzchnia',
    distance: 'Odległość',
    actualCalc: 'Obliczenia w toku',
    selectOnTheMap: 'Wybierz na mapie  aby zmierzyć',
    mapAction: 'Pomiar mapy',
    mapActionLine: 'Zmierz mapę',
    min: 'Minimum',
    max: 'Maksimum',
    total: 'Razem',
    recommended: 'Zalecane',
    standard: 'Norma',
    noFile: 'Nie wybrano żadnych plików',
    email: 'Nie wybrano pliku    E-mail',
    search: 'Szukaj',
    results: 'Wyniki',
    noresults: {
      short: 'Brak wyników',
      long: 'Nie ma wyników dla Twojego wyszukiwania'
    },
    true: 'Tak',
    false: 'Nie',
    noOptions: 'Brak opcji',
    noSelected: 'Nie wybrano',
    agentView: 'widok agenta',
    managerView: 'widok menedżera',
    unit: '0 jednostek | x count} jednostek | x count} jednostek'
  },

  empties: {
    noResults: {
      title: 'Brak wyników',
      descr: 'Proszę wybrać inne parametry wyszukiwania'
    }
  },
  // Area component: {
  areaMeasurement: {
    damageArea: 'Obszar uszkodzeń',
    measurementTipe: 'W metrach kwadratowych',
    heightMeasurement: 'Wysokość',
    widhtMeasurement: 'Szerokość'
  }
}
